<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline></svg>
</template>
<script>
export default {
    
}
</script>
<style scoped>
    .icon{
         stroke: currentColor;
         height:1rem;
        margin-top:-0.3rem;
        margin-right:0.4rem;
    }
</style>